import validate, { isEmpty } from "validate.js";
import { dateFormat, format, isBeforeDate, isDateBeforeStart, maxLength, presence, range, ValidationField, Validator } from "~/extensions/utils";
import { isNullOrUndefined, MypageMessageFormat } from "~/extensions/utils/DefineFunction";
import { commonStore } from "~/store/CommonStore";
export class ShinjoKouzaValidator extends Validator {
    constructor(data, kouzaNumber) {
        const isBlank = (value) => {
            return value === null || value === undefined || String(value).trim() === "";
        };
        const hasKouzaInfo = !isBlank(data.bankName) ||
            !isBlank(data.bansName) ||
            !isBlank(kouzaNumber) ||
            !isBlank(data.kouzaName) ||
            !isBlank(data.kouzaKana);
        const attributes = {
            ...data,
            kouzaNumber
        };
        const constraints = {
            bankName: {
                length: maxLength(15),
                kouzaRequired: { hasKouzaInfo },
                invalidChar: {}
            },
            bansName: {
                length: maxLength(15),
                kouzaRequired: { hasKouzaInfo },
                invalidChar: {}
            },
            kouzaNumber: {
                kouzaRequired: { hasKouzaInfo },
                invalidKouzaNo: {},
                invalidKouzaNoZero: {}
            },
            kouzaName: {
                length: maxLength(24),
                kouzaRequired: { hasKouzaInfo },
                invalidChar: {}
            },
            kouzaKana: {
                length: maxLength(48),
                kouzaRequired: { hasKouzaInfo },
                invalidKouzaKana: {}
            }
        };
        super(attributes, constraints);
        this.bankName = new ValidationField("bankName", attributes, constraints);
        this.bansName = new ValidationField("bansName", attributes, constraints);
        this.kouzaNumber = new ValidationField("kouzaNumber", attributes, constraints);
        this.kouzaName = new ValidationField("kouzaName", attributes, constraints);
        this.kouzaKana = new ValidationField("kouzaKana", attributes, constraints);
        // 口座情報が1項目でも入力されている場合は、
        // 口座情報5項目すべてをバリデーション対象にする
        if (hasKouzaInfo) {
            this.bankName.modified = true;
            this.bansName.modified = true;
            this.kouzaNumber.modified = true;
            this.kouzaName.modified = true;
            this.kouzaKana.modified = true;
        }
    }
    bankName;
    bansName;
    kouzaNumber;
    kouzaName;
    kouzaKana;
}
export class ShinjWorkPlaceValidator extends Validator {
    constructor(data) {
        const constrains = {
            workplaceName: {
                length: maxLength(60)
            },
            yearsOfService: {
                range: range(0, 99)
            },
            workplaceTel: {
                format: format({ pattern: new RegExp("^(|\\d{3}-?\\d{4}-?\\d{4})$"), message: commonStore.messages.PV0012 })
            },
            workplacePostcode: {
                format: format({ pattern: new RegExp("^(|[0-9]{3}-?[0-9]{4})$"), message: commonStore.messages.PV0014 })
            },
            address1: {
                length: maxLength(20)
            },
            address2: {
                length: maxLength(20)
            },
            address3: {
                length: maxLength(20)
            }
        };
        super(data, constrains);
        this.workplaceName = new ValidationField("workplaceName", data, constrains);
        this.yearsOfService = new ValidationField("yearsOfService", data, constrains);
        this.workplaceTel = new ValidationField("workplaceTel", data, constrains);
        this.workplacePostcode = new ValidationField("workplacePostcode", data, constrains);
        this.address1 = new ValidationField("address1", data, constrains);
        this.address2 = new ValidationField("address2", data, constrains);
        this.address3 = new ValidationField("address3", data, constrains);
    }
    workplaceName;
    yearsOfService;
    workplaceTel;
    workplacePostcode;
    address1;
    address2;
    address3;
}
export class ShinjoEmergencyContactValidator extends Validator {
    constructor(data) {
        const dateFormatErrorMessage = commonStore.messages.PV0005;
        const constrains = {
            name: {
                length: maxLength(30)
            },
            dateOfBirth: {
                dateFormat: dateFormat(dateFormatErrorMessage)
            },
            tel: {
                format: format({ pattern: new RegExp("^(|\\d{3}-?\\d{4}-?\\d{4})$"), message: commonStore.messages.PV0012 })
            },
            postCode: {
                format: format({ pattern: new RegExp("^(|[0-9]{3}-?[0-9]{4})$"), message: commonStore.messages.PV0014 })
            },
            address1: {
                length: maxLength(20)
            },
            address2: {
                length: maxLength(20)
            },
            address3: {
                length: maxLength(20)
            },
            workplaceName: {
                length: maxLength(60)
            },
            yearsOfService: {
                range: range(0, 99)
            },
            workplaceTel: {
                format: format({ pattern: new RegExp("^(|\\d{3}-?\\d{4}-?\\d{4})$"), message: commonStore.messages.PV0012 })
            },
            workplacePostcode: {
                format: format({ pattern: new RegExp("^(|[0-9]{3}-?[0-9]{4})$"), message: commonStore.messages.PV0014 })
            },
            workplaceAddress1: {
                length: maxLength(20)
            },
            workplaceAddress2: {
                length: maxLength(20)
            },
            workplaceAddress3: {
                length: maxLength(20)
            }
        };
        super(data, constrains);
        this.name = new ValidationField("name", data, constrains);
        this.dateOfBirth = new ValidationField("dateOfBirth", data, constrains);
        this.tel = new ValidationField("tel", data, constrains);
        this.postCode = new ValidationField("postCode", data, constrains);
        this.address1 = new ValidationField("address1", data, constrains);
        this.address2 = new ValidationField("address2", data, constrains);
        this.address3 = new ValidationField("address3", data, constrains);
        this.workplaceName = new ValidationField("workplaceName", data, constrains);
        this.yearsOfService = new ValidationField("yearsOfService", data, constrains);
        this.workplaceTel = new ValidationField("workplaceTel", data, constrains);
        this.workplacePostcode = new ValidationField("workplacePostcode", data, constrains);
        this.workplaceAddress1 = new ValidationField("workplaceAddress1", data, constrains);
        this.workplaceAddress2 = new ValidationField("workplaceAddress2", data, constrains);
        this.workplaceAddress3 = new ValidationField("workplaceAddress3", data, constrains);
    }
    name;
    dateOfBirth;
    tel;
    postCode;
    address1;
    address2;
    address3;
    workplaceName;
    yearsOfService;
    workplaceTel;
    workplacePostcode;
    workplaceAddress1;
    workplaceAddress2;
    workplaceAddress3;
}
export class ShinjoKyojushaValidator extends Validator {
    constructor(data) {
        const dateFormatErrorMessage = commonStore.messages.PV0005;
        const constrains = {
            name: {
                length: maxLength(30)
            },
            dateOfBirth: {
                dateFormat: dateFormat(dateFormatErrorMessage)
            },
            tel: {
                format: format({ pattern: new RegExp("^(|\\d{3}-?\\d{4}-?\\d{4})$"), message: commonStore.messages.PV0012 })
            },
            relationship: {
                length: maxLength(10)
            }
        };
        super(data, constrains);
        this.name = new ValidationField("name", data, constrains);
        this.dateOfBirth = new ValidationField("dateOfBirth", data, constrains);
        this.tel = new ValidationField("tel", data, constrains);
        this.relationship = new ValidationField("relationship", data, constrains);
    }
    name;
    dateOfBirth;
    tel;
    relationship;
}
export class ShinjoCarValidator extends Validator {
    constructor(data) {
        const constrains = {
            manufacturer: {
                length: maxLength(30)
            },
            carModel: {
                length: maxLength(30)
            },
            carColor: {
                length: maxLength(20)
            },
            displacement: {
                range: range(0, 9999)
            },
            registrationNumber: {
                length: maxLength(30)
            }
        };
        super(data, constrains);
        this.manufacturer = new ValidationField("manufacturer", data, constrains);
        this.carModel = new ValidationField("carModel", data, constrains);
        this.carColor = new ValidationField("carColor", data, constrains);
        this.displacement = new ValidationField("displacement", data, constrains);
        this.registrationNumber = new ValidationField("registrationNumber", data, constrains);
    }
    manufacturer;
    carModel;
    carColor;
    displacement;
    registrationNumber;
}
export class ShinjoInsuranceValidator extends Validator {
    constructor(data) {
        const requiredErrorMessage = commonStore.messages.PV0001;
        const dateFormatErrorMessage = commonStore.messages.PV0005;
        const constrains = {
            insuranceCompany: {
                InsuranceIfRequired: presence(false, requiredErrorMessage),
                length: maxLength(30)
            },
            insuranceType: {
                InsuranceIfRequired: presence(false, requiredErrorMessage),
                length: maxLength(30)
            },
            contractStartDate: {
                InsuranceIfRequired: presence(false, requiredErrorMessage),
                dateFormat: dateFormat(dateFormatErrorMessage)
            },
            contractEndDate: {
                InsuranceIfRequired: presence(false, requiredErrorMessage),
                dateFormat: dateFormat(dateFormatErrorMessage),
                isContractEndDateBeforStart: isDateBeforeStart(MypageMessageFormat(commonStore.messages.PV0006, { val: "契約終了日", val1: "契約開始日" }), "startAt")
            }
        };
        super(data, constrains);
        this.insuranceCompany = new ValidationField("insuranceCompany", data, constrains);
        this.insuranceType = new ValidationField("insuranceType", data, constrains);
        this.contractStartDate = new ValidationField("contractStartDate", data, constrains);
        this.contractEndDate = new ValidationField("contractEndDate", data, constrains);
    }
    insuranceCompany;
    insuranceType;
    contractStartDate;
    contractEndDate;
}
/** 口座情報でいずれかが入力されている場合必須 */
validate.validators.kouzaRequired = function (value, options) {
    if (!options.hasKouzaInfo) {
        return null;
    }
    if (value === null || value === undefined || String(value).trim() === "") {
        return commonStore.messages.PV0001;
    }
    return null;
};
/** 使用できない文字が含まれているか */
validate.validators.invalidChar = function (value, options, key, attributes) {
    const invalidCharPattern = /^[\s\w\u2010-\u2015\u3041-\u3096\u30A1-\u30FC\u3400-\u9FFF\uF900-\uFAFF\uD840-\uD87F々〇■\u0020-\u007E\u3000-\u303F\u3040-\u309F\u2160-\u2169\u2460-\u2474\uFF41-\uFF5A\uFF21-\uFF3A\uFF10-\uFF19\uFF0D]*$/;
    if (isNullOrUndefined(value) || isEmpty(value)) {
        return null;
    }
    if (!invalidCharPattern.test(value)) {
        return commonStore.messages.PV0020;
    }
    return null;
};
/** 口座番号が7桁かどうか */
validate.validators.invalidKouzaNo = function (value, options, key, attributes) {
    const invalidKouzaNoPattern = /^\d{7}$/;
    if (isNullOrUndefined(value) || isEmpty(value)) {
        return null;
    }
    if (!invalidKouzaNoPattern.test(value)) {
        return commonStore.messages.PV0018;
    }
    return null;
};
/** 口座番号が全ての値が0かどうか */
validate.validators.invalidKouzaNoZero = function (value, options, key, attributes) {
    if (isNullOrUndefined(value) || isEmpty(value)) {
        return null;
    }
    if (String(value) === "0000000") {
        return commonStore.messages.PV0025;
    }
    return null;
};
/** 口座カナチェック */
validate.validators.invalidKouzaKana = function (value) {
    const invalidKouzaKanaPattern = /^[ｦ-ﾟ A-Z0-9().,-/¥｢｣]+$/;
    if (value === null || value === undefined || String(value).trim() === "") {
        return null;
    }
    if (!invalidKouzaKanaPattern.test(value)) {
        return commonStore.messages.PV0024;
    }
    return null;
};
/** いづれかが入力されている場合必須 */
validate.validators.InsuranceIfRequired = function (value, options, key, attributes) {
    if (!attributes.hasSettings) {
        return null;
    }
    if (isNullOrUndefined(value) || isEmpty(value)) {
        return options.message;
    }
    return null;
};
/** 納品希望期間（開始） 過去日チェック - 入力変更時のみ  */
validate.validators.isContractEndDateBeforStart = function (value, options, key, attributes) {
    if (isNullOrUndefined(value) || isEmpty(value)) {
        return null;
    }
    const target = new Date(value);
    const baseDate = new Date(attributes.contractStartDate);
    if (isBeforeDate(baseDate, target)) {
        return options.message;
    }
    return null;
};
